import React from 'react';
import styled from 'styled-components';
import Alert from 'components/Alert';

const StyledAlert = styled(Alert)`
  margin-top: 16px;
`;

const DateOfServiceError = () => {
  return (
    <StyledAlert variant="danger" label="Invalid date">
      Your insurance does not cover you on the selected date, as it is outside the dates
      of your contract.
    </StyledAlert>
  );
};

export default DateOfServiceError;
